unit View.Vendas_Servicos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils,
  UConstantes, UUtils, UWeb.Enum;

type
  TFViewVendas_ServicosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbcliente_id: TLabel;
    edcliente_id: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbnota_numero: TLabel;
    ednota_numero: TDBEdit;
    lbnota_emissao: TLabel;
    ednota_emissao: TDBEdit;
    lbnota_entrada_saida: TLabel;
    ednota_entrada_saida: TDBEdit;
    lbdata_movimento: TLabel;
    eddata_movimento: TDBEdit;
    lbnota_valor_acrescimos: TLabel;
    ednota_valor_acrescimos: TDBEdit;
    lbnota_valor_desconto: TLabel;
    ednota_valor_desconto: TDBEdit;
    lbnota_valor_total: TLabel;
    ednota_valor_total: TDBEdit;
    lbnota_origem: TLabel;
    ednota_origem: TDBEdit;
    lbnota_base_issqn: TLabel;
    ednota_base_issqn: TDBEdit;
    lbnota_valor_issqn: TLabel;
    ednota_valor_issqn: TDBEdit;
    lbnota_valor_issqn_retido: TLabel;
    ednota_valor_issqn_retido: TDBEdit;
    lbformas_pagamentos_id: TLabel;
    edformas_pagamentos_id: TDBEdit;
    lbcliente_fidelidade_id: TLabel;
    edcliente_fidelidade_id: TDBEdit;
    lbobservacoes: TLabel;
    edobservacoes: TDBEdit;
    lbnome_consumidor_final: TLabel;
    ednome_consumidor_final: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientVendas_ServicosGet: TXDataWebClient;
    Vendas_ServicosDataset: TXDataWebDataSet;
    Vendas_ServicosDatasetid: TIntegerField;
    Vendas_ServicosDatasetaliado_id: TIntegerField;
    Vendas_ServicosDatasetdata_base_id: TIntegerField;
    Vendas_ServicosDatasetcliente_id: TIntegerField;
    Vendas_ServicosDatasetfuncionario_id: TIntegerField;
    Vendas_ServicosDatasetnota_numero: TStringField;
    Vendas_ServicosDatasetnota_emissao: TDateTimeField;
    Vendas_ServicosDatasetnota_entrada_saida: TDateTimeField;
    Vendas_ServicosDatasetdata_movimento: TDateTimeField;
    Vendas_ServicosDatasetnota_valor_acrescimos: TFloatField;
    Vendas_ServicosDatasetnota_valor_desconto: TFloatField;
    Vendas_ServicosDatasetnota_valor_total: TFloatField;
    Vendas_ServicosDatasetnota_origem: TIntegerField;
    Vendas_ServicosDatasetnota_base_issqn: TFloatField;
    Vendas_ServicosDatasetnota_valor_issqn: TFloatField;
    Vendas_ServicosDatasetnota_valor_issqn_retido: TFloatField;
    Vendas_ServicosDatasetnfse_id: TIntegerField;
    Vendas_ServicosDatasetosv_oss_id: TIntegerField;
    Vendas_ServicosDatasetose_oss_id: TIntegerField;
    Vendas_ServicosDatasetpet_prontuarios_id: TIntegerField;
    Vendas_ServicosDatasetpet_vendas_id: TIntegerField;
    Vendas_ServicosDatasetmensalidade_id: TIntegerField;
    Vendas_ServicosDatasetformas_pagamentos_id: TIntegerField;
    Vendas_ServicosDatasetcliente_fidelidade_id: TIntegerField;
    Vendas_ServicosDatasetconvenios_id: TIntegerField;
    Vendas_ServicosDatasetdependentes_id: TIntegerField;
    Vendas_ServicosDatasetobservacoes: TStringField;
    Vendas_ServicosDatasetnome_consumidor_final: TStringField;
    Vendas_ServicosDatasetcodigo_interno: TIntegerField;
    Vendas_ServicosDatasetexcluido: TBooleanField;
    Vendas_ServicosDatasetinclusao: TDateTimeField;
    Vendas_ServicosDatasetalteracao: TDateTimeField;
    Vendas_ServicosDatasetexclusao: TDateTimeField;
    pnlFormDados: TPanel;
    cbxexcluido: TDBCheckBox;
    Vendas_ServicosDatasetclienterazao_social_nome: TStringField;
    Vendas_ServicosDatasetfuncionarionome: TStringField;
    Vendas_ServicosDatasetnfsedata_emissao: TDateField;
    Vendas_ServicosDatasetnfsechave_acesso: TStringField;
    Vendas_ServicosDatasetcliente_fidrazao_social_nome: TStringField;
    lbchave_acesso: TLabel;
    lbnfse_emissao: TLabel;
    pnlFormNfe: TPanel;
    edchave_acesso: TDBEdit;
    ednfe_transmissao: TDBEdit;
    btnCopiarChaveAcesso: TButton;
    btnNfseTab: TButton;
    lbPaginationInfoItens: TLabel;
    tblItens: TDBTableControl;
    cbPageSizeItens: TComboBox;
    edSearchItens: TEdit;
    pnlItensPromocao: TPanel;
    btnItensTab: TButton;
    lcPaginatorItens: TListControl;
    cdsItens: TXDataWebDataSet;
    dtsItens: TDataSource;
    tmrConsultaItens: TTimer;
    cdsItensservico_id: TIntegerField;
    cdsItensquantidade: TFloatField;
    cdsItensservico_preco: TFloatField;
    cdsItensserviconome: TStringField;
    cdsItensservicocodigo_interno: TIntegerField;
    cdsItensservicounidadesigla: TStringField;
    cdsItensvalor_desconto: TFloatField;
    cdsItensvalor_acrescimo: TFloatField;
    lbPaginationInfoAReceber: TLabel;
    lbPaginationInfoRecebimentos: TLabel;
    pnlTabelaAReceber: TPanel;
    tblAReceber: TDBTableControl;
    lcPaginatorAReceber: TListControl;
    tblRecebimentos: TDBTableControl;
    pnlTabelaPagamentos: TPanel;
    btnFinanceiroTab: TButton;
    btnRecebimentosTab: TButton;
    lcPaginatorRecebimentos: TListControl;
    cdsRecebimentos: TXDataWebDataSet;
    cdsRecebimentosvalor_bruto_recebido: TFloatField;
    cdsRecebimentosdata_recebimento: TDateTimeField;
    cdsRecebimentosmodalidadenome: TStringField;
    cdsRecebimentosareceberdocumento: TStringField;
    cdsRecebimentosareceberparcela: TXDataWebDatasetField;
    dtsRecebimentos: TDataSource;
    dtsAReceber: TDataSource;
    cdsAReceber: TXDataWebDataSet;
    cdsAReceberdocumento: TStringField;
    cdsAReceberparcela: TStringField;
    cdsAReceberemissao: TDateTimeField;
    cdsARecebervencimento: TDateTimeField;
    cdsARecebervalor_total: TFloatField;
    cdsARecebervalor_saldo_pendente: TFloatField;
    cdsARecebervalor_pago: TFloatField;
    cdsItenstotal_liquido: TStringField;
    cdsItensvalor_total: TFloatField;
    cdsItensvalor_issqn_retido: TFloatField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientVendas_ServicosGetLoad(Response: TXDataClientResponse);
    procedure Vendas_ServicosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure Vendas_ServicosDatasetformas_pagamentos_idGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure btnNfseTabClick(Sender: TObject);
    procedure btnCopiarChaveAcessoClick(Sender: TObject);
    procedure btnItensTabClick(Sender: TObject);
    procedure tblItensGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cbPageSizeItensChange(Sender: TObject);
    procedure edSearchItensKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchItensKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaItensTimer(Sender: TObject);
    procedure btnFinanceiroTabClick(Sender: TObject);
    procedure btnRecebimentosTabClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure tblAReceberGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblAReceberGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblRecebimentosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cdsItenstotal_liquidoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginItens,
    FGridPluginAReceber,
    FGridPluginRecebimentos : TGridPlugin;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure CarregarAReceber;
    procedure CarregarRecebimentos;
    procedure ConfigurarPermissoes;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewVendas_ServicosEdit: TFViewVendas_ServicosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewVendas_ServicosEdit }

procedure TFViewVendas_ServicosEdit.btnCopiarChaveAcessoClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave de acesso copiada com sucesso!', 'Cópia de chave de acesso',
    edchave_acesso.Text);
end;

procedure TFViewVendas_ServicosEdit.btnFinanceiroTabClick(Sender: TObject);
begin
  if TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
    CarregarAReceber
  else
  begin
    TUtils.SelecionarTab('#line-recebimentos-tab');
    CarregarRecebimentos;
  end;
end;

procedure TFViewVendas_ServicosEdit.btnItensTabClick(Sender: TObject);
begin
  if cdsItens.Tag = 0 then
  begin
    cdsItens.Tag := 1;

    FGridPluginItens := TGridPlugin.Create(tblItens, cdsItens, lcPaginatorItens, lbPaginationInfoItens);
    FGridPluginItens.FDatasetPlugin.FFilterPadrao := '(venda_servico_id eq ' + edid.Text +')';
    FGridPluginItens.FDatasetPlugin.FOrderByPadrao := 'codigo_interno asc';
    FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text));
    FGridPluginItens.SetFilterText(edSearchItens.Text);
    FGridPluginItens.Load;
  end;
end;

procedure TFViewVendas_ServicosEdit.btnNfseTabClick(Sender: TObject);
begin
  if edchave_acesso.Text = '' then
    btnCopiarChaveAcesso.Enabled := False;
end;

procedure TFViewVendas_ServicosEdit.btnRecebimentosTabClick(Sender: TObject);
begin
  CarregarRecebimentos;
end;

procedure TFViewVendas_ServicosEdit.CarregarAReceber;
begin
  if cdsAReceber.Tag = 0 then
  begin
    cdsAReceber.Tag := 1;

    FGridPluginAReceber := TGridPlugin.Create(tblAReceber, cdsAReceber, lcPaginatorAReceber,
      lbPaginationInfoAReceber);
    FGridPluginAReceber.FDatasetPlugin.FFilterPadrao := '(venda_servico_id eq ' + edid.Text +')';
    FGridPluginAReceber.FDatasetPlugin.FOrderByPadrao := 'vencimento asc';
    FGridPluginAReceber.SetPageSize(10);
    FGridPluginAReceber.SetFilterText(EmptyStr);
    FGridPluginAReceber.Load;
  end;
end;

procedure TFViewVendas_ServicosEdit.CarregarRecebimentos;
begin
  if cdsRecebimentos.Tag = 0 then
  begin
    cdsRecebimentos.Tag := 1;

    FGridPluginRecebimentos := TGridPlugin.Create(tblRecebimentos, cdsRecebimentos, lcPaginatorRecebimentos,
      lbPaginationInfoRecebimentos);
    FGridPluginRecebimentos.FDatasetPlugin.FFilterPadrao := '(areceber/venda_servico_id eq ' + edid.Text +')';
    FGridPluginRecebimentos.FDatasetPlugin.FOrderByPadrao := 'data_recebimento desc, codigo_interno desc';
    FGridPluginRecebimentos.SetPageSize(10);
    FGridPluginRecebimentos.SetFilterText(EmptyStr);
    FGridPluginRecebimentos.Load;
  end;
end;

procedure TFViewVendas_ServicosEdit.cbPageSizeItensChange(Sender: TObject);
begin
  FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text), True);
end;

procedure TFViewVendas_ServicosEdit.cdsItenstotal_liquidoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
var
  lTotalLiquido : Float64;
begin
  lTotalLiquido := cdsItens.FieldByName('valor_total').AsFloat - cdsItens.FieldByName('valor_desconto').AsFloat -
    cdsItens.FieldByName('valor_issqn_retido').AsFloat + cdsItens.FieldByName('valor_acrescimo').AsFloat;

  Text := FormatFloat('#,##0.00', lTotalLiquido);
end;

procedure TFViewVendas_ServicosEdit.ConfigurarPermissoes;
begin
  if not TUtils.PossuiPermissao(cdsItens.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-itens-tab');
    TUtils.RemoverElementoPorId('line-itens');
  end;

  if not TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) and
    not TUtils.PossuiPermissao(cdsRecebimentos.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-financeiro-tab');
    TUtils.RemoverElementoPorId('line-financeiro');
  end
  else if not TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-areceber-tab');
    TUtils.RemoverElementoPorId('line-areceber');
  end
  else if not TUtils.PossuiPermissao(cdsRecebimentos.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-recebimentos-tab');
    TUtils.RemoverElementoPorId('line-recebimentos');
  end;

  if not TUtils.PossuiPermissao('nfse', TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-nfse-tab');
    TUtils.RemoverElementoPorId('line-nfse');
  end;
end;

class function TFViewVendas_ServicosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewVendas_ServicosEdit.edSearchItensKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaItens.Enabled := False;

  if Key = 13 then
    FGridPluginItens.SetFilterText(edSearchItens.Text, True);
end;

procedure TFViewVendas_ServicosEdit.edSearchItensKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaItens.Interval := FTimerConsulta;
  tmrConsultaItens.Enabled := True;
end;

procedure TFViewVendas_ServicosEdit.InsertEntity;
begin
  Vendas_ServicosDataset.Close;
  Vendas_ServicosDataset.SetJsonData('{}');
  Vendas_ServicosDataset.Open;
  Vendas_ServicosDataset.Insert;
end;

class function TFViewVendas_ServicosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewVendas_ServicosEdit(AForm).FInserting := AInserting;
    TFViewVendas_ServicosEdit(AForm).FId := AId;
    TFViewVendas_ServicosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewVendas_ServicosEdit(AForm).InsertEntity
    else
      TFViewVendas_ServicosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewVendas_ServicosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewVendas_ServicosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Vendas_ServicosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Vendas_ServicosDataset.EntitySetName
    )
  );
  XDataClientVendas_ServicosGet.Get(Vendas_ServicosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewVendas_ServicosEdit.tblAReceberGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAReceber.Columns[ACol].DataField, ['valor_total', 'valor_saldo_pendente',
      'valor_pago', 'documento']) of
      0, 1, 2: AClassName := 'text-end';
      3: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendas_ServicosEdit.tblAReceberGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
var
  lTituloVencido : Boolean;
begin
  if ARow > 0 then
  begin
    lTituloVencido := (tblAReceber.DataSource.DataSet.FieldByName('valor_saldo_pendente').AsFloat > 0) and
      (StrToDate(tblAReceber.DataSource.DataSet.FieldByName('vencimento').AsString) < Date);

    if lTituloVencido then
      AValue := '<p class="text-danger">' + AValue + '</p>'
  end;
end;

procedure TFViewVendas_ServicosEdit.tblItensGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblItens.Columns[ACol].DataField, ['servico.nome', 'quantidade',
     'servico_preco', 'valor_total', 'valor_desconto', 'valor_acrescimo']) of
      0: AClassName := 'text-start';
      1, 2, 3, 4, 5: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendas_ServicosEdit.tblRecebimentosGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if cdsRecebimentos.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblRecebimentos.Columns[ACol].DataField, ['valor_bruto_recebido', 'modalidade.nome',
      'areceber.documento']) of
      0: AClassName := 'text-end';
      1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendas_ServicosEdit.tmrConsultaItensTimer(Sender: TObject);
begin
  FGridPluginItens.SetFilterText(edSearchItens.Text, True);

  tmrConsultaItens.Enabled := False;
  tmrConsultaItens.Interval := FTimerConsulta;
end;

procedure TFViewVendas_ServicosEdit.XDataClientVendas_ServicosGetLoad(Response: TXDataClientResponse);
begin
  Vendas_ServicosDataset.Close;
  Vendas_ServicosDataset.SetJsonData(Response.Result);
  Vendas_ServicosDataset.Open;
  
  Vendas_ServicosDataset.Edit;  
end;

procedure TFViewVendas_ServicosEdit.Vendas_ServicosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewVendas_ServicosEdit.Vendas_ServicosDatasetformas_pagamentos_idGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  case Sender.AsInteger of
    1 : Text := 'À VISTA';
    2 : Text := 'A PRAZO';
    3 : Text := 'CARTÃO';
    4 : Text := 'CHEQUE';
    else Text := 'OUTROS';
  end;
end;

procedure TFViewVendas_ServicosEdit.WebFormShow(Sender: TObject);
begin
  ConfigurarPermissoes;
end;

procedure TFViewVendas_ServicosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewVendas_ServicosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.vendas_servicos.form.lbid');
  lbcliente_id := TLabel.Create('view.vendas_servicos.form.lbcliente_id');
  lbfuncionario_id := TLabel.Create('view.vendas_servicos.form.lbfuncionario_id');
  lbnota_numero := TLabel.Create('view.vendas_servicos.form.lbnota_numero');
  lbnota_emissao := TLabel.Create('view.vendas_servicos.form.lbnota_emissao');
  lbnota_entrada_saida := TLabel.Create('view.vendas_servicos.form.lbnota_entrada_saida');
  lbdata_movimento := TLabel.Create('view.vendas_servicos.form.lbdata_movimento');
  lbnota_valor_acrescimos := TLabel.Create('view.vendas_servicos.form.lbnota_valor_acrescimos');
  lbnota_valor_desconto := TLabel.Create('view.vendas_servicos.form.lbnota_valor_desconto');
  lbnota_valor_total := TLabel.Create('view.vendas_servicos.form.lbnota_valor_total');
  lbnota_origem := TLabel.Create('view.vendas_servicos.form.lbnota_origem');
  lbnota_base_issqn := TLabel.Create('view.vendas_servicos.form.lbnota_base_issqn');
  lbnota_valor_issqn := TLabel.Create('view.vendas_servicos.form.lbnota_valor_issqn');
  lbnota_valor_issqn_retido := TLabel.Create('view.vendas_servicos.form.lbnota_valor_issqn_retido');
  lbformas_pagamentos_id := TLabel.Create('view.vendas_servicos.form.lbformas_pagamentos_id');
  lbcliente_fidelidade_id := TLabel.Create('view.vendas_servicos.form.lbcliente_fidelidade_id');
  lbobservacoes := TLabel.Create('view.vendas_servicos.form.lbobservacoes');
  lbnome_consumidor_final := TLabel.Create('view.vendas_servicos.form.lbnome_consumidor_final');
  lbcodigo_interno := TLabel.Create('view.vendas_servicos.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.vendas_servicos.form.lbexcluido');
  lbinclusao := TLabel.Create('view.vendas_servicos.form.lbinclusao');
  lbalteracao := TLabel.Create('view.vendas_servicos.form.lbalteracao');
  lbexclusao := TLabel.Create('view.vendas_servicos.form.lbexclusao');
  lbchave_acesso := TLabel.Create('view.vendas_servicos.form.lbchave_acesso');
  lbnfse_emissao := TLabel.Create('view.vendas_servicos.form.lbnfse_emissao');
  lbPaginationInfoItens := TLabel.Create('lbPaginationInfoItens');
  lbPaginationInfoAReceber := TLabel.Create('lbPaginationInfoAReceber');
  lbPaginationInfoRecebimentos := TLabel.Create('lbPaginationInfoRecebimentos');
  btCancel := TButton.Create('view.vendas_servicos.form.btBack');
  edid := TDBEdit.Create('view.vendas_servicos.form.edid');
  edcliente_id := TDBEdit.Create('view.vendas_servicos.form.edcliente_id');
  edfuncionario_id := TDBEdit.Create('view.vendas_servicos.form.edfuncionario_id');
  ednota_numero := TDBEdit.Create('view.vendas_servicos.form.ednota_numero');
  ednota_emissao := TDBEdit.Create('view.vendas_servicos.form.ednota_emissao');
  ednota_entrada_saida := TDBEdit.Create('view.vendas_servicos.form.ednota_entrada_saida');
  eddata_movimento := TDBEdit.Create('view.vendas_servicos.form.eddata_movimento');
  ednota_valor_acrescimos := TDBEdit.Create('view.vendas_servicos.form.ednota_valor_acrescimos');
  ednota_valor_desconto := TDBEdit.Create('view.vendas_servicos.form.ednota_valor_desconto');
  ednota_valor_total := TDBEdit.Create('view.vendas_servicos.form.ednota_valor_total');
  ednota_origem := TDBEdit.Create('view.vendas_servicos.form.ednota_origem');
  ednota_base_issqn := TDBEdit.Create('view.vendas_servicos.form.ednota_base_issqn');
  ednota_valor_issqn := TDBEdit.Create('view.vendas_servicos.form.ednota_valor_issqn');
  ednota_valor_issqn_retido := TDBEdit.Create('view.vendas_servicos.form.ednota_valor_issqn_retido');
  edformas_pagamentos_id := TDBEdit.Create('view.vendas_servicos.form.edformas_pagamentos_id');
  edcliente_fidelidade_id := TDBEdit.Create('view.vendas_servicos.form.edcliente_fidelidade_id');
  edobservacoes := TDBEdit.Create('view.vendas_servicos.form.edobservacoes');
  ednome_consumidor_final := TDBEdit.Create('view.vendas_servicos.form.ednome_consumidor_final');
  edcodigo_interno := TDBEdit.Create('view.vendas_servicos.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.vendas_servicos.form.edinclusao');
  edalteracao := TDBEdit.Create('view.vendas_servicos.form.edalteracao');
  edexclusao := TDBEdit.Create('view.vendas_servicos.form.edexclusao');
  pnlFormDados := TPanel.Create(Self);
  cbxexcluido := TDBCheckBox.Create('view.vendas_servicos.form.cbxexcluido');
  pnlFormNfe := TPanel.Create(Self);
  edchave_acesso := TDBEdit.Create('view.vendas_servicos.form.edchave_acesso');
  ednfe_transmissao := TDBEdit.Create('view.vendas_servicos.form.ednfse_emissao');
  btnCopiarChaveAcesso := TButton.Create('btnCopiarChaveAcesso');
  btnNfseTab := TButton.Create('line-nfse-tab');
  tblItens := TDBTableControl.Create('tblItens');
  cbPageSizeItens := TComboBox.Create('cbPageSizeItens');
  edSearchItens := TEdit.Create('edSearchItens');
  pnlItensPromocao := TPanel.Create(Self);
  btnItensTab := TButton.Create('line-itens-tab');
  lcPaginatorItens := TListControl.Create('lcPaginatorItens');
  pnlTabelaAReceber := TPanel.Create(Self);
  tblAReceber := TDBTableControl.Create('tblAReceber');
  lcPaginatorAReceber := TListControl.Create('lcPaginatorAReceber');
  tblRecebimentos := TDBTableControl.Create('tblRecebimentos');
  pnlTabelaPagamentos := TPanel.Create(Self);
  btnFinanceiroTab := TButton.Create('line-financeiro-tab');
  btnRecebimentosTab := TButton.Create('line-recebimentos-tab');
  lcPaginatorRecebimentos := TListControl.Create('lcPaginatorRecebimentos');
  DataSource := TDataSource.Create(Self);
  Vendas_ServicosDataset := TXDataWebDataSet.Create(Self);
  Vendas_ServicosDatasetid := TIntegerField.Create(Self);
  Vendas_ServicosDatasetaliado_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetdata_base_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetcliente_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetfuncionario_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetnota_numero := TStringField.Create(Self);
  Vendas_ServicosDatasetnota_emissao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetnota_entrada_saida := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetdata_movimento := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetnota_valor_acrescimos := TFloatField.Create(Self);
  Vendas_ServicosDatasetnota_valor_desconto := TFloatField.Create(Self);
  Vendas_ServicosDatasetnota_valor_total := TFloatField.Create(Self);
  Vendas_ServicosDatasetnota_origem := TIntegerField.Create(Self);
  Vendas_ServicosDatasetnota_base_issqn := TFloatField.Create(Self);
  Vendas_ServicosDatasetnota_valor_issqn := TFloatField.Create(Self);
  Vendas_ServicosDatasetnota_valor_issqn_retido := TFloatField.Create(Self);
  Vendas_ServicosDatasetnfse_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetosv_oss_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetose_oss_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetpet_prontuarios_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetpet_vendas_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetmensalidade_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetformas_pagamentos_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetcliente_fidelidade_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetconvenios_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetdependentes_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetobservacoes := TStringField.Create(Self);
  Vendas_ServicosDatasetnome_consumidor_final := TStringField.Create(Self);
  Vendas_ServicosDatasetcodigo_interno := TIntegerField.Create(Self);
  Vendas_ServicosDatasetexcluido := TBooleanField.Create(Self);
  Vendas_ServicosDatasetinclusao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetalteracao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetexclusao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetclienterazao_social_nome := TStringField.Create(Self);
  Vendas_ServicosDatasetfuncionarionome := TStringField.Create(Self);
  Vendas_ServicosDatasetnfsedata_emissao := TDateField.Create(Self);
  Vendas_ServicosDatasetnfsechave_acesso := TStringField.Create(Self);
  Vendas_ServicosDatasetcliente_fidrazao_social_nome := TStringField.Create(Self);
  XDataClientVendas_ServicosGet := TXDataWebClient.Create(Self);
  cdsItens := TXDataWebDataSet.Create(Self);
  cdsItensservico_id := TIntegerField.Create(Self);
  cdsItensquantidade := TFloatField.Create(Self);
  cdsItensservico_preco := TFloatField.Create(Self);
  cdsItensserviconome := TStringField.Create(Self);
  cdsItensservicocodigo_interno := TIntegerField.Create(Self);
  cdsItensservicounidadesigla := TStringField.Create(Self);
  cdsItensvalor_desconto := TFloatField.Create(Self);
  cdsItensvalor_acrescimo := TFloatField.Create(Self);
  cdsItenstotal_liquido := TStringField.Create(Self);
  cdsItensvalor_total := TFloatField.Create(Self);
  cdsItensvalor_issqn_retido := TFloatField.Create(Self);
  dtsItens := TDataSource.Create(Self);
  tmrConsultaItens := TTimer.Create(Self);
  cdsRecebimentos := TXDataWebDataSet.Create(Self);
  cdsRecebimentosvalor_bruto_recebido := TFloatField.Create(Self);
  cdsRecebimentosdata_recebimento := TDateTimeField.Create(Self);
  cdsRecebimentosmodalidadenome := TStringField.Create(Self);
  cdsRecebimentosareceberdocumento := TStringField.Create(Self);
  cdsRecebimentosareceberparcela := TXDataWebDatasetField.Create(Self);
  dtsRecebimentos := TDataSource.Create(Self);
  dtsAReceber := TDataSource.Create(Self);
  cdsAReceber := TXDataWebDataSet.Create(Self);
  cdsAReceberdocumento := TStringField.Create(Self);
  cdsAReceberparcela := TStringField.Create(Self);
  cdsAReceberemissao := TDateTimeField.Create(Self);
  cdsARecebervencimento := TDateTimeField.Create(Self);
  cdsARecebervalor_total := TFloatField.Create(Self);
  cdsARecebervalor_saldo_pendente := TFloatField.Create(Self);
  cdsARecebervalor_pago := TFloatField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbcliente_id.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  lbnota_numero.BeforeLoadDFMValues;
  lbnota_emissao.BeforeLoadDFMValues;
  lbnota_entrada_saida.BeforeLoadDFMValues;
  lbdata_movimento.BeforeLoadDFMValues;
  lbnota_valor_acrescimos.BeforeLoadDFMValues;
  lbnota_valor_desconto.BeforeLoadDFMValues;
  lbnota_valor_total.BeforeLoadDFMValues;
  lbnota_origem.BeforeLoadDFMValues;
  lbnota_base_issqn.BeforeLoadDFMValues;
  lbnota_valor_issqn.BeforeLoadDFMValues;
  lbnota_valor_issqn_retido.BeforeLoadDFMValues;
  lbformas_pagamentos_id.BeforeLoadDFMValues;
  lbcliente_fidelidade_id.BeforeLoadDFMValues;
  lbobservacoes.BeforeLoadDFMValues;
  lbnome_consumidor_final.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbchave_acesso.BeforeLoadDFMValues;
  lbnfse_emissao.BeforeLoadDFMValues;
  lbPaginationInfoItens.BeforeLoadDFMValues;
  lbPaginationInfoAReceber.BeforeLoadDFMValues;
  lbPaginationInfoRecebimentos.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edcliente_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  ednota_numero.BeforeLoadDFMValues;
  ednota_emissao.BeforeLoadDFMValues;
  ednota_entrada_saida.BeforeLoadDFMValues;
  eddata_movimento.BeforeLoadDFMValues;
  ednota_valor_acrescimos.BeforeLoadDFMValues;
  ednota_valor_desconto.BeforeLoadDFMValues;
  ednota_valor_total.BeforeLoadDFMValues;
  ednota_origem.BeforeLoadDFMValues;
  ednota_base_issqn.BeforeLoadDFMValues;
  ednota_valor_issqn.BeforeLoadDFMValues;
  ednota_valor_issqn_retido.BeforeLoadDFMValues;
  edformas_pagamentos_id.BeforeLoadDFMValues;
  edcliente_fidelidade_id.BeforeLoadDFMValues;
  edobservacoes.BeforeLoadDFMValues;
  ednome_consumidor_final.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  pnlFormDados.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  pnlFormNfe.BeforeLoadDFMValues;
  edchave_acesso.BeforeLoadDFMValues;
  ednfe_transmissao.BeforeLoadDFMValues;
  btnCopiarChaveAcesso.BeforeLoadDFMValues;
  btnNfseTab.BeforeLoadDFMValues;
  tblItens.BeforeLoadDFMValues;
  cbPageSizeItens.BeforeLoadDFMValues;
  edSearchItens.BeforeLoadDFMValues;
  pnlItensPromocao.BeforeLoadDFMValues;
  btnItensTab.BeforeLoadDFMValues;
  lcPaginatorItens.BeforeLoadDFMValues;
  pnlTabelaAReceber.BeforeLoadDFMValues;
  tblAReceber.BeforeLoadDFMValues;
  lcPaginatorAReceber.BeforeLoadDFMValues;
  tblRecebimentos.BeforeLoadDFMValues;
  pnlTabelaPagamentos.BeforeLoadDFMValues;
  btnFinanceiroTab.BeforeLoadDFMValues;
  btnRecebimentosTab.BeforeLoadDFMValues;
  lcPaginatorRecebimentos.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Vendas_ServicosDataset.BeforeLoadDFMValues;
  Vendas_ServicosDatasetid.BeforeLoadDFMValues;
  Vendas_ServicosDatasetaliado_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetdata_base_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetcliente_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetfuncionario_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_numero.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_emissao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_entrada_saida.BeforeLoadDFMValues;
  Vendas_ServicosDatasetdata_movimento.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_valor_acrescimos.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_valor_desconto.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_valor_total.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_origem.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_base_issqn.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_valor_issqn.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_valor_issqn_retido.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnfse_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetosv_oss_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetose_oss_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetpet_prontuarios_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetpet_vendas_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetmensalidade_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetformas_pagamentos_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetcliente_fidelidade_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetconvenios_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetdependentes_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetobservacoes.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnome_consumidor_final.BeforeLoadDFMValues;
  Vendas_ServicosDatasetcodigo_interno.BeforeLoadDFMValues;
  Vendas_ServicosDatasetexcluido.BeforeLoadDFMValues;
  Vendas_ServicosDatasetinclusao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetalteracao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetexclusao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetclienterazao_social_nome.BeforeLoadDFMValues;
  Vendas_ServicosDatasetfuncionarionome.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnfsedata_emissao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnfsechave_acesso.BeforeLoadDFMValues;
  Vendas_ServicosDatasetcliente_fidrazao_social_nome.BeforeLoadDFMValues;
  XDataClientVendas_ServicosGet.BeforeLoadDFMValues;
  cdsItens.BeforeLoadDFMValues;
  cdsItensservico_id.BeforeLoadDFMValues;
  cdsItensquantidade.BeforeLoadDFMValues;
  cdsItensservico_preco.BeforeLoadDFMValues;
  cdsItensserviconome.BeforeLoadDFMValues;
  cdsItensservicocodigo_interno.BeforeLoadDFMValues;
  cdsItensservicounidadesigla.BeforeLoadDFMValues;
  cdsItensvalor_desconto.BeforeLoadDFMValues;
  cdsItensvalor_acrescimo.BeforeLoadDFMValues;
  cdsItenstotal_liquido.BeforeLoadDFMValues;
  cdsItensvalor_total.BeforeLoadDFMValues;
  cdsItensvalor_issqn_retido.BeforeLoadDFMValues;
  dtsItens.BeforeLoadDFMValues;
  tmrConsultaItens.BeforeLoadDFMValues;
  cdsRecebimentos.BeforeLoadDFMValues;
  cdsRecebimentosvalor_bruto_recebido.BeforeLoadDFMValues;
  cdsRecebimentosdata_recebimento.BeforeLoadDFMValues;
  cdsRecebimentosmodalidadenome.BeforeLoadDFMValues;
  cdsRecebimentosareceberdocumento.BeforeLoadDFMValues;
  cdsRecebimentosareceberparcela.BeforeLoadDFMValues;
  dtsRecebimentos.BeforeLoadDFMValues;
  dtsAReceber.BeforeLoadDFMValues;
  cdsAReceber.BeforeLoadDFMValues;
  cdsAReceberdocumento.BeforeLoadDFMValues;
  cdsAReceberparcela.BeforeLoadDFMValues;
  cdsAReceberemissao.BeforeLoadDFMValues;
  cdsARecebervencimento.BeforeLoadDFMValues;
  cdsARecebervalor_total.BeforeLoadDFMValues;
  cdsARecebervalor_saldo_pendente.BeforeLoadDFMValues;
  cdsARecebervalor_pago.BeforeLoadDFMValues;
  try
    Name := 'FViewVendas_ServicosEdit';
    Width := 768;
    Height := 522;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 32;
    lbid.Width := 56;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv.:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbcliente_id.SetParentComponent(Self);
    lbcliente_id.Name := 'lbcliente_id';
    lbcliente_id.Left := 8;
    lbcliente_id.Top := 60;
    lbcliente_id.Width := 37;
    lbcliente_id.Height := 13;
    lbcliente_id.Caption := 'Cliente:';
    lbcliente_id.HeightPercent := 100.000000000000000000;
    lbcliente_id.WidthPercent := 100.000000000000000000;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 8;
    lbfuncionario_id.Top := 87;
    lbfuncionario_id.Width := 59;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'Funcion'#225'rio:';
    lbfuncionario_id.HeightPercent := 100.000000000000000000;
    lbfuncionario_id.WidthPercent := 100.000000000000000000;
    lbnota_numero.SetParentComponent(Self);
    lbnota_numero.Name := 'lbnota_numero';
    lbnota_numero.Left := 8;
    lbnota_numero.Top := 114;
    lbnota_numero.Width := 58;
    lbnota_numero.Height := 13;
    lbnota_numero.Caption := 'Documento:';
    lbnota_numero.HeightPercent := 100.000000000000000000;
    lbnota_numero.WidthPercent := 100.000000000000000000;
    lbnota_emissao.SetParentComponent(Self);
    lbnota_emissao.Name := 'lbnota_emissao';
    lbnota_emissao.Left := 8;
    lbnota_emissao.Top := 141;
    lbnota_emissao.Width := 42;
    lbnota_emissao.Height := 13;
    lbnota_emissao.Caption := 'Emiss'#227'o:';
    lbnota_emissao.HeightPercent := 100.000000000000000000;
    lbnota_emissao.WidthPercent := 100.000000000000000000;
    lbnota_entrada_saida.SetParentComponent(Self);
    lbnota_entrada_saida.Name := 'lbnota_entrada_saida';
    lbnota_entrada_saida.Left := 8;
    lbnota_entrada_saida.Top := 168;
    lbnota_entrada_saida.Width := 30;
    lbnota_entrada_saida.Height := 13;
    lbnota_entrada_saida.Caption := 'Sa'#237'da:';
    lbnota_entrada_saida.HeightPercent := 100.000000000000000000;
    lbnota_entrada_saida.WidthPercent := 100.000000000000000000;
    lbdata_movimento.SetParentComponent(Self);
    lbdata_movimento.Name := 'lbdata_movimento';
    lbdata_movimento.Left := 8;
    lbdata_movimento.Top := 195;
    lbdata_movimento.Width := 54;
    lbdata_movimento.Height := 13;
    lbdata_movimento.Caption := 'Data Mov.:';
    lbdata_movimento.HeightPercent := 100.000000000000000000;
    lbdata_movimento.WidthPercent := 100.000000000000000000;
    lbnota_valor_acrescimos.SetParentComponent(Self);
    lbnota_valor_acrescimos.Name := 'lbnota_valor_acrescimos';
    lbnota_valor_acrescimos.Left := 8;
    lbnota_valor_acrescimos.Top := 222;
    lbnota_valor_acrescimos.Width := 57;
    lbnota_valor_acrescimos.Height := 13;
    lbnota_valor_acrescimos.Caption := 'Acr'#233'scimos:';
    lbnota_valor_acrescimos.HeightPercent := 100.000000000000000000;
    lbnota_valor_acrescimos.WidthPercent := 100.000000000000000000;
    lbnota_valor_desconto.SetParentComponent(Self);
    lbnota_valor_desconto.Name := 'lbnota_valor_desconto';
    lbnota_valor_desconto.Left := 8;
    lbnota_valor_desconto.Top := 249;
    lbnota_valor_desconto.Width := 49;
    lbnota_valor_desconto.Height := 13;
    lbnota_valor_desconto.Caption := 'Desconto:';
    lbnota_valor_desconto.HeightPercent := 100.000000000000000000;
    lbnota_valor_desconto.WidthPercent := 100.000000000000000000;
    lbnota_valor_total.SetParentComponent(Self);
    lbnota_valor_total.Name := 'lbnota_valor_total';
    lbnota_valor_total.Left := 8;
    lbnota_valor_total.Top := 276;
    lbnota_valor_total.Width := 28;
    lbnota_valor_total.Height := 13;
    lbnota_valor_total.Caption := 'Total:';
    lbnota_valor_total.HeightPercent := 100.000000000000000000;
    lbnota_valor_total.WidthPercent := 100.000000000000000000;
    lbnota_origem.SetParentComponent(Self);
    lbnota_origem.Name := 'lbnota_origem';
    lbnota_origem.Left := 8;
    lbnota_origem.Top := 303;
    lbnota_origem.Width := 38;
    lbnota_origem.Height := 13;
    lbnota_origem.Caption := 'Origem:';
    lbnota_origem.HeightPercent := 100.000000000000000000;
    lbnota_origem.WidthPercent := 100.000000000000000000;
    lbnota_base_issqn.SetParentComponent(Self);
    lbnota_base_issqn.Name := 'lbnota_base_issqn';
    lbnota_base_issqn.Left := 8;
    lbnota_base_issqn.Top := 330;
    lbnota_base_issqn.Width := 61;
    lbnota_base_issqn.Height := 13;
    lbnota_base_issqn.Caption := 'Base ISSQN:';
    lbnota_base_issqn.HeightPercent := 100.000000000000000000;
    lbnota_base_issqn.WidthPercent := 100.000000000000000000;
    lbnota_valor_issqn.SetParentComponent(Self);
    lbnota_valor_issqn.Name := 'lbnota_valor_issqn';
    lbnota_valor_issqn.Left := 266;
    lbnota_valor_issqn.Top := 276;
    lbnota_valor_issqn.Width := 62;
    lbnota_valor_issqn.Height := 13;
    lbnota_valor_issqn.Caption := 'Valor ISSQN:';
    lbnota_valor_issqn.HeightPercent := 100.000000000000000000;
    lbnota_valor_issqn.WidthPercent := 100.000000000000000000;
    lbnota_valor_issqn_retido.SetParentComponent(Self);
    lbnota_valor_issqn_retido.Name := 'lbnota_valor_issqn_retido';
    lbnota_valor_issqn_retido.Left := 266;
    lbnota_valor_issqn_retido.Top := 303;
    lbnota_valor_issqn_retido.Width := 86;
    lbnota_valor_issqn_retido.Height := 13;
    lbnota_valor_issqn_retido.Caption := 'Valor ISSQN Ret.:';
    lbnota_valor_issqn_retido.HeightPercent := 100.000000000000000000;
    lbnota_valor_issqn_retido.WidthPercent := 100.000000000000000000;
    lbformas_pagamentos_id.SetParentComponent(Self);
    lbformas_pagamentos_id.Name := 'lbformas_pagamentos_id';
    lbformas_pagamentos_id.Left := 266;
    lbformas_pagamentos_id.Top := 34;
    lbformas_pagamentos_id.Width := 91;
    lbformas_pagamentos_id.Height := 13;
    lbformas_pagamentos_id.Caption := 'Forma Pagamento:';
    lbformas_pagamentos_id.HeightPercent := 100.000000000000000000;
    lbformas_pagamentos_id.WidthPercent := 100.000000000000000000;
    lbcliente_fidelidade_id.SetParentComponent(Self);
    lbcliente_fidelidade_id.Name := 'lbcliente_fidelidade_id';
    lbcliente_fidelidade_id.Left := 266;
    lbcliente_fidelidade_id.Top := 61;
    lbcliente_fidelidade_id.Width := 88;
    lbcliente_fidelidade_id.Height := 13;
    lbcliente_fidelidade_id.Caption := 'Cliente Fidelidade:';
    lbcliente_fidelidade_id.HeightPercent := 100.000000000000000000;
    lbcliente_fidelidade_id.WidthPercent := 100.000000000000000000;
    lbobservacoes.SetParentComponent(Self);
    lbobservacoes.Name := 'lbobservacoes';
    lbobservacoes.Left := 266;
    lbobservacoes.Top := 87;
    lbobservacoes.Width := 67;
    lbobservacoes.Height := 13;
    lbobservacoes.Caption := 'Observa'#231#245'es:';
    lbobservacoes.HeightPercent := 100.000000000000000000;
    lbobservacoes.WidthPercent := 100.000000000000000000;
    lbnome_consumidor_final.SetParentComponent(Self);
    lbnome_consumidor_final.Name := 'lbnome_consumidor_final';
    lbnome_consumidor_final.Left := 266;
    lbnome_consumidor_final.Top := 114;
    lbnome_consumidor_final.Width := 85;
    lbnome_consumidor_final.Height := 13;
    lbnome_consumidor_final.Caption := 'Consumidor Final:';
    lbnome_consumidor_final.HeightPercent := 100.000000000000000000;
    lbnome_consumidor_final.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 266;
    lbcodigo_interno.Top := 141;
    lbcodigo_interno.Width := 51;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret.:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 266;
    lbexcluido.Top := 168;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 266;
    lbinclusao.Top := 195;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 266;
    lbalteracao.Top := 222;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 266;
    lbexclusao.Top := 249;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbchave_acesso.SetParentComponent(Self);
    lbchave_acesso.Name := 'lbchave_acesso';
    lbchave_acesso.Left := 521;
    lbchave_acesso.Top := 24;
    lbchave_acesso.Width := 87;
    lbchave_acesso.Height := 13;
    lbchave_acesso.Caption := 'Chave de Acesso:';
    lbchave_acesso.HeightPercent := 100.000000000000000000;
    lbchave_acesso.WidthPercent := 100.000000000000000000;
    lbnfse_emissao.SetParentComponent(Self);
    lbnfse_emissao.Name := 'lbnfse_emissao';
    lbnfse_emissao.Left := 521;
    lbnfse_emissao.Top := 50;
    lbnfse_emissao.Width := 68;
    lbnfse_emissao.Height := 13;
    lbnfse_emissao.Caption := 'Data Emiss'#227'o:';
    lbnfse_emissao.HeightPercent := 100.000000000000000000;
    lbnfse_emissao.WidthPercent := 100.000000000000000000;
    lbPaginationInfoItens.SetParentComponent(Self);
    lbPaginationInfoItens.Name := 'lbPaginationInfoItens';
    lbPaginationInfoItens.Left := 521;
    lbPaginationInfoItens.Top := 281;
    lbPaginationInfoItens.Width := 141;
    lbPaginationInfoItens.Height := 13;
    lbPaginationInfoItens.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoItens.HeightPercent := 100.000000000000000000;
    lbPaginationInfoItens.WidthPercent := 100.000000000000000000;
    lbPaginationInfoAReceber.SetParentComponent(Self);
    lbPaginationInfoAReceber.Name := 'lbPaginationInfoAReceber';
    lbPaginationInfoAReceber.Left := 262;
    lbPaginationInfoAReceber.Top := 479;
    lbPaginationInfoAReceber.Width := 141;
    lbPaginationInfoAReceber.Height := 13;
    lbPaginationInfoAReceber.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoAReceber.Color := clBtnFace;
    lbPaginationInfoAReceber.HeightPercent := 100.000000000000000000;
    lbPaginationInfoAReceber.WidthPercent := 100.000000000000000000;
    lbPaginationInfoRecebimentos.SetParentComponent(Self);
    lbPaginationInfoRecebimentos.Name := 'lbPaginationInfoRecebimentos';
    lbPaginationInfoRecebimentos.Left := 519;
    lbPaginationInfoRecebimentos.Top := 474;
    lbPaginationInfoRecebimentos.Width := 141;
    lbPaginationInfoRecebimentos.Height := 13;
    lbPaginationInfoRecebimentos.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoRecebimentos.Color := clBtnFace;
    lbPaginationInfoRecebimentos.HeightPercent := 100.000000000000000000;
    lbPaginationInfoRecebimentos.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 8;
    btCancel.Top := 368;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 109;
    edid.Top := 29;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edcliente_id.SetParentComponent(Self);
    edcliente_id.Name := 'edcliente_id';
    edcliente_id.Left := 109;
    edcliente_id.Top := 57;
    edcliente_id.Width := 120;
    edcliente_id.Height := 21;
    edcliente_id.Enabled := False;
    edcliente_id.HeightPercent := 100.000000000000000000;
    edcliente_id.TabOrder := 9;
    edcliente_id.Text := 'edcliente_id';
    edcliente_id.WidthPercent := 100.000000000000000000;
    edcliente_id.DataField := 'cliente.razao_social_nome';
    edcliente_id.DataSource := DataSource;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 109;
    edfuncionario_id.Top := 84;
    edfuncionario_id.Width := 120;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := False;
    edfuncionario_id.HeightPercent := 100.000000000000000000;
    edfuncionario_id.TabOrder := 10;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.WidthPercent := 100.000000000000000000;
    edfuncionario_id.DataField := 'funcionario.nome';
    edfuncionario_id.DataSource := DataSource;
    ednota_numero.SetParentComponent(Self);
    ednota_numero.Name := 'ednota_numero';
    ednota_numero.Left := 109;
    ednota_numero.Top := 111;
    ednota_numero.Width := 120;
    ednota_numero.Height := 21;
    ednota_numero.Enabled := False;
    ednota_numero.HeightPercent := 100.000000000000000000;
    ednota_numero.TabOrder := 11;
    ednota_numero.Text := 'ednota_numero';
    ednota_numero.WidthPercent := 100.000000000000000000;
    ednota_numero.DataField := 'nota_numero';
    ednota_numero.DataSource := DataSource;
    ednota_emissao.SetParentComponent(Self);
    ednota_emissao.Name := 'ednota_emissao';
    ednota_emissao.Left := 109;
    ednota_emissao.Top := 138;
    ednota_emissao.Width := 120;
    ednota_emissao.Height := 21;
    ednota_emissao.Enabled := False;
    ednota_emissao.HeightPercent := 100.000000000000000000;
    ednota_emissao.TabOrder := 12;
    ednota_emissao.Text := 'ednota_emissao';
    ednota_emissao.WidthPercent := 100.000000000000000000;
    ednota_emissao.DataField := 'nota_emissao';
    ednota_emissao.DataSource := DataSource;
    ednota_entrada_saida.SetParentComponent(Self);
    ednota_entrada_saida.Name := 'ednota_entrada_saida';
    ednota_entrada_saida.Left := 109;
    ednota_entrada_saida.Top := 165;
    ednota_entrada_saida.Width := 120;
    ednota_entrada_saida.Height := 21;
    ednota_entrada_saida.Enabled := False;
    ednota_entrada_saida.HeightPercent := 100.000000000000000000;
    ednota_entrada_saida.TabOrder := 13;
    ednota_entrada_saida.Text := 'ednota_entrada_saida';
    ednota_entrada_saida.WidthPercent := 100.000000000000000000;
    ednota_entrada_saida.DataField := 'nota_entrada_saida';
    ednota_entrada_saida.DataSource := DataSource;
    eddata_movimento.SetParentComponent(Self);
    eddata_movimento.Name := 'eddata_movimento';
    eddata_movimento.Left := 109;
    eddata_movimento.Top := 192;
    eddata_movimento.Width := 120;
    eddata_movimento.Height := 21;
    eddata_movimento.Enabled := False;
    eddata_movimento.HeightPercent := 100.000000000000000000;
    eddata_movimento.TabOrder := 14;
    eddata_movimento.Text := 'eddata_movimento';
    eddata_movimento.WidthPercent := 100.000000000000000000;
    eddata_movimento.DataField := 'data_movimento';
    eddata_movimento.DataSource := DataSource;
    ednota_valor_acrescimos.SetParentComponent(Self);
    ednota_valor_acrescimos.Name := 'ednota_valor_acrescimos';
    ednota_valor_acrescimos.Left := 109;
    ednota_valor_acrescimos.Top := 219;
    ednota_valor_acrescimos.Width := 120;
    ednota_valor_acrescimos.Height := 21;
    ednota_valor_acrescimos.Enabled := False;
    ednota_valor_acrescimos.HeightPercent := 100.000000000000000000;
    ednota_valor_acrescimos.TabOrder := 15;
    ednota_valor_acrescimos.Text := 'ednota_valor_acrescimos';
    ednota_valor_acrescimos.WidthPercent := 100.000000000000000000;
    ednota_valor_acrescimos.DataField := 'nota_valor_acrescimos';
    ednota_valor_acrescimos.DataSource := DataSource;
    ednota_valor_desconto.SetParentComponent(Self);
    ednota_valor_desconto.Name := 'ednota_valor_desconto';
    ednota_valor_desconto.Left := 109;
    ednota_valor_desconto.Top := 246;
    ednota_valor_desconto.Width := 120;
    ednota_valor_desconto.Height := 21;
    ednota_valor_desconto.Enabled := False;
    ednota_valor_desconto.HeightPercent := 100.000000000000000000;
    ednota_valor_desconto.TabOrder := 16;
    ednota_valor_desconto.Text := 'ednota_valor_desconto';
    ednota_valor_desconto.WidthPercent := 100.000000000000000000;
    ednota_valor_desconto.DataField := 'nota_valor_desconto';
    ednota_valor_desconto.DataSource := DataSource;
    ednota_valor_total.SetParentComponent(Self);
    ednota_valor_total.Name := 'ednota_valor_total';
    ednota_valor_total.Left := 109;
    ednota_valor_total.Top := 273;
    ednota_valor_total.Width := 120;
    ednota_valor_total.Height := 21;
    ednota_valor_total.Enabled := False;
    ednota_valor_total.HeightPercent := 100.000000000000000000;
    ednota_valor_total.TabOrder := 17;
    ednota_valor_total.Text := 'ednota_valor_total';
    ednota_valor_total.WidthPercent := 100.000000000000000000;
    ednota_valor_total.DataField := 'nota_valor_total';
    ednota_valor_total.DataSource := DataSource;
    ednota_origem.SetParentComponent(Self);
    ednota_origem.Name := 'ednota_origem';
    ednota_origem.Left := 109;
    ednota_origem.Top := 300;
    ednota_origem.Width := 120;
    ednota_origem.Height := 21;
    ednota_origem.Enabled := False;
    ednota_origem.HeightPercent := 100.000000000000000000;
    ednota_origem.TabOrder := 18;
    ednota_origem.Text := 'ednota_origem';
    ednota_origem.WidthPercent := 100.000000000000000000;
    ednota_origem.DataField := 'nota_origem';
    ednota_origem.DataSource := DataSource;
    ednota_base_issqn.SetParentComponent(Self);
    ednota_base_issqn.Name := 'ednota_base_issqn';
    ednota_base_issqn.Left := 109;
    ednota_base_issqn.Top := 327;
    ednota_base_issqn.Width := 120;
    ednota_base_issqn.Height := 21;
    ednota_base_issqn.Enabled := False;
    ednota_base_issqn.HeightPercent := 100.000000000000000000;
    ednota_base_issqn.TabOrder := 19;
    ednota_base_issqn.Text := 'ednota_base_issqn';
    ednota_base_issqn.WidthPercent := 100.000000000000000000;
    ednota_base_issqn.DataField := 'nota_base_issqn';
    ednota_base_issqn.DataSource := DataSource;
    ednota_valor_issqn.SetParentComponent(Self);
    ednota_valor_issqn.Name := 'ednota_valor_issqn';
    ednota_valor_issqn.Left := 367;
    ednota_valor_issqn.Top := 273;
    ednota_valor_issqn.Width := 120;
    ednota_valor_issqn.Height := 21;
    ednota_valor_issqn.Enabled := False;
    ednota_valor_issqn.HeightPercent := 100.000000000000000000;
    ednota_valor_issqn.TabOrder := 20;
    ednota_valor_issqn.Text := 'ednota_valor_issqn';
    ednota_valor_issqn.WidthPercent := 100.000000000000000000;
    ednota_valor_issqn.DataField := 'nota_valor_issqn';
    ednota_valor_issqn.DataSource := DataSource;
    ednota_valor_issqn_retido.SetParentComponent(Self);
    ednota_valor_issqn_retido.Name := 'ednota_valor_issqn_retido';
    ednota_valor_issqn_retido.Left := 367;
    ednota_valor_issqn_retido.Top := 300;
    ednota_valor_issqn_retido.Width := 120;
    ednota_valor_issqn_retido.Height := 21;
    ednota_valor_issqn_retido.Enabled := False;
    ednota_valor_issqn_retido.HeightPercent := 100.000000000000000000;
    ednota_valor_issqn_retido.TabOrder := 21;
    ednota_valor_issqn_retido.Text := 'ednota_valor_issqn_retido';
    ednota_valor_issqn_retido.WidthPercent := 100.000000000000000000;
    ednota_valor_issqn_retido.DataField := 'nota_valor_issqn_retido';
    ednota_valor_issqn_retido.DataSource := DataSource;
    edformas_pagamentos_id.SetParentComponent(Self);
    edformas_pagamentos_id.Name := 'edformas_pagamentos_id';
    edformas_pagamentos_id.Left := 367;
    edformas_pagamentos_id.Top := 31;
    edformas_pagamentos_id.Width := 120;
    edformas_pagamentos_id.Height := 21;
    edformas_pagamentos_id.Enabled := False;
    edformas_pagamentos_id.HeightPercent := 100.000000000000000000;
    edformas_pagamentos_id.TabOrder := 28;
    edformas_pagamentos_id.Text := 'edformas_pagamentos_id';
    edformas_pagamentos_id.WidthPercent := 100.000000000000000000;
    edformas_pagamentos_id.DataField := 'formas_pagamentos_id';
    edformas_pagamentos_id.DataSource := DataSource;
    edcliente_fidelidade_id.SetParentComponent(Self);
    edcliente_fidelidade_id.Name := 'edcliente_fidelidade_id';
    edcliente_fidelidade_id.Left := 367;
    edcliente_fidelidade_id.Top := 58;
    edcliente_fidelidade_id.Width := 120;
    edcliente_fidelidade_id.Height := 21;
    edcliente_fidelidade_id.Enabled := False;
    edcliente_fidelidade_id.HeightPercent := 100.000000000000000000;
    edcliente_fidelidade_id.TabOrder := 29;
    edcliente_fidelidade_id.Text := 'edcliente_fidelidade_id';
    edcliente_fidelidade_id.WidthPercent := 100.000000000000000000;
    edcliente_fidelidade_id.DataField := 'cliente_fid.razao_social_nome';
    edcliente_fidelidade_id.DataSource := DataSource;
    edobservacoes.SetParentComponent(Self);
    edobservacoes.Name := 'edobservacoes';
    edobservacoes.Left := 367;
    edobservacoes.Top := 84;
    edobservacoes.Width := 120;
    edobservacoes.Height := 21;
    edobservacoes.Enabled := False;
    edobservacoes.HeightPercent := 100.000000000000000000;
    edobservacoes.TabOrder := 32;
    edobservacoes.Text := 'edobservacoes';
    edobservacoes.WidthPercent := 100.000000000000000000;
    edobservacoes.DataField := 'observacoes';
    edobservacoes.DataSource := DataSource;
    ednome_consumidor_final.SetParentComponent(Self);
    ednome_consumidor_final.Name := 'ednome_consumidor_final';
    ednome_consumidor_final.Left := 367;
    ednome_consumidor_final.Top := 111;
    ednome_consumidor_final.Width := 120;
    ednome_consumidor_final.Height := 21;
    ednome_consumidor_final.Enabled := False;
    ednome_consumidor_final.HeightPercent := 100.000000000000000000;
    ednome_consumidor_final.TabOrder := 33;
    ednome_consumidor_final.Text := 'ednome_consumidor_final';
    ednome_consumidor_final.WidthPercent := 100.000000000000000000;
    ednome_consumidor_final.DataField := 'nome_consumidor_final';
    ednome_consumidor_final.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 367;
    edcodigo_interno.Top := 138;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 34;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 367;
    edinclusao.Top := 192;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 36;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 367;
    edalteracao.Top := 219;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 37;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 367;
    edexclusao.Top := 246;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 38;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    pnlFormDados.SetParentComponent(Self);
    pnlFormDados.Name := 'pnlFormDados';
    pnlFormDados.Left := 8;
    pnlFormDados.Top := 2;
    pnlFormDados.Width := 479;
    pnlFormDados.Height := 17;
    pnlFormDados.Caption := 'Espa'#231'o Form Dados';
    pnlFormDados.ChildOrder := 23;
    pnlFormDados.Color := clInfoText;
    pnlFormDados.Font.Charset := DEFAULT_CHARSET;
    pnlFormDados.Font.Color := clWhite;
    pnlFormDados.Font.Height := -11;
    pnlFormDados.Font.Name := 'Tahoma';
    pnlFormDados.Font.Style := [fsBold];
    pnlFormDados.ParentFont := False;
    pnlFormDados.TabOrder := 23;
    pnlFormDados.Visible := False;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 367;
    cbxexcluido.Top := 164;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    pnlFormNfe.SetParentComponent(Self);
    pnlFormNfe.Name := 'pnlFormNfe';
    pnlFormNfe.Left := 521;
    pnlFormNfe.Top := 2;
    pnlFormNfe.Width := 225;
    pnlFormNfe.Height := 17;
    pnlFormNfe.Caption := 'Espa'#231'o NFe';
    pnlFormNfe.ChildOrder := 23;
    pnlFormNfe.Color := clInfoText;
    pnlFormNfe.Font.Charset := DEFAULT_CHARSET;
    pnlFormNfe.Font.Color := clWhite;
    pnlFormNfe.Font.Height := -11;
    pnlFormNfe.Font.Name := 'Tahoma';
    pnlFormNfe.Font.Style := [fsBold];
    pnlFormNfe.ParentFont := False;
    pnlFormNfe.TabOrder := 25;
    pnlFormNfe.Visible := False;
    edchave_acesso.SetParentComponent(Self);
    edchave_acesso.Name := 'edchave_acesso';
    edchave_acesso.Left := 616;
    edchave_acesso.Top := 21;
    edchave_acesso.Width := 100;
    edchave_acesso.Height := 21;
    edchave_acesso.ChildOrder := 145;
    edchave_acesso.Enabled := False;
    edchave_acesso.HeightPercent := 100.000000000000000000;
    edchave_acesso.TabOrder := 28;
    edchave_acesso.Text := 'edchave_acesso';
    edchave_acesso.WidthPercent := 100.000000000000000000;
    edchave_acesso.DataField := 'nfse.chave_acesso';
    edchave_acesso.DataSource := DataSource;
    ednfe_transmissao.SetParentComponent(Self);
    ednfe_transmissao.Name := 'ednfe_transmissao';
    ednfe_transmissao.Left := 616;
    ednfe_transmissao.Top := 47;
    ednfe_transmissao.Width := 100;
    ednfe_transmissao.Height := 21;
    ednfe_transmissao.ChildOrder := 145;
    ednfe_transmissao.Enabled := False;
    ednfe_transmissao.HeightPercent := 100.000000000000000000;
    ednfe_transmissao.TabOrder := 28;
    ednfe_transmissao.Text := 'ednfe_transmissao';
    ednfe_transmissao.WidthPercent := 100.000000000000000000;
    ednfe_transmissao.DataField := 'nfse.data_emissao';
    ednfe_transmissao.DataSource := DataSource;
    btnCopiarChaveAcesso.SetParentComponent(Self);
    btnCopiarChaveAcesso.Name := 'btnCopiarChaveAcesso';
    btnCopiarChaveAcesso.Left := 716;
    btnCopiarChaveAcesso.Top := 21;
    btnCopiarChaveAcesso.Width := 30;
    btnCopiarChaveAcesso.Height := 21;
    btnCopiarChaveAcesso.ChildOrder := 22;
    btnCopiarChaveAcesso.HeightPercent := 100.000000000000000000;
    btnCopiarChaveAcesso.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChaveAcesso, Self, 'OnClick', 'btnCopiarChaveAcessoClick');
    btnNfseTab.SetParentComponent(Self);
    btnNfseTab.Name := 'btnNfseTab';
    btnNfseTab.Left := 520;
    btnNfseTab.Top := 73;
    btnNfseTab.Width := 78;
    btnNfseTab.Height := 25;
    btnNfseTab.Caption := 'NFSe';
    btnNfseTab.ChildOrder := 34;
    btnNfseTab.HeightPercent := 100.000000000000000000;
    btnNfseTab.TabOrder := 1;
    btnNfseTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnNfseTab, Self, 'OnClick', 'btnNfseTabClick');
    tblItens.SetParentComponent(Self);
    tblItens.Name := 'tblItens';
    tblItens.Left := 519;
    tblItens.Top := 177;
    tblItens.Width := 226;
    tblItens.Height := 102;
    tblItens.ElementClassName := 'table-responsive';
    tblItens.BorderColor := clSilver;
    tblItens.ChildOrder := 28;
    tblItens.ColHeader := False;
    tblItens.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblItens, Self, 'OnGetCellClass', 'tblItensGetCellClass');
    tblItens.Columns.Clear;
    with tblItens.Columns.Add do
    begin
      DataField := 'servico.codigo_interno';
      Title := 'C'#243'd. Servi'#231'o';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'servico.nome';
      Title := 'Servi'#231'o';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'servico.unidade.sigla';
      Title := 'Unidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'servico_preco';
      Title := 'Pre'#231'o';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'valor_desconto';
      Title := 'Desconto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'valor_acrescimo';
      Title := 'Acr'#233'scimo';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'total_liquido';
      Title := 'Total';
    end;
    tblItens.DataSource := dtsItens;
    cbPageSizeItens.SetParentComponent(Self);
    cbPageSizeItens.Name := 'cbPageSizeItens';
    cbPageSizeItens.Left := 520;
    cbPageSizeItens.Top := 151;
    cbPageSizeItens.Width := 81;
    cbPageSizeItens.Height := 21;
    cbPageSizeItens.HeightPercent := 100.000000000000000000;
    cbPageSizeItens.TabOrder := 2;
    cbPageSizeItens.Text := '10';
    cbPageSizeItens.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeItens, Self, 'OnChange', 'cbPageSizeItensChange');
    cbPageSizeItens.ItemIndex := 0;
    cbPageSizeItens.Items.BeginUpdate;
    try
      cbPageSizeItens.Items.Clear;
      cbPageSizeItens.Items.Add('10');
      cbPageSizeItens.Items.Add('25');
      cbPageSizeItens.Items.Add('50');
      cbPageSizeItens.Items.Add('100');
    finally
      cbPageSizeItens.Items.EndUpdate;
    end;
    edSearchItens.SetParentComponent(Self);
    edSearchItens.Name := 'edSearchItens';
    edSearchItens.Left := 607;
    edSearchItens.Top := 151;
    edSearchItens.Width := 54;
    edSearchItens.Height := 21;
    edSearchItens.ChildOrder := 30;
    edSearchItens.HeightPercent := 100.000000000000000000;
    edSearchItens.TabOrder := 3;
    edSearchItens.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchItens, Self, 'OnKeyDown', 'edSearchItensKeyDown');
    SetEvent(edSearchItens, Self, 'OnKeyUp', 'edSearchItensKeyUp');
    pnlItensPromocao.SetParentComponent(Self);
    pnlItensPromocao.Name := 'pnlItensPromocao';
    pnlItensPromocao.Left := 520;
    pnlItensPromocao.Top := 127;
    pnlItensPromocao.Width := 225;
    pnlItensPromocao.Height := 17;
    pnlItensPromocao.Caption := 'Espa'#231'o tabela Itens';
    pnlItensPromocao.ChildOrder := 23;
    pnlItensPromocao.Color := clInfoText;
    pnlItensPromocao.Font.Charset := DEFAULT_CHARSET;
    pnlItensPromocao.Font.Color := clWhite;
    pnlItensPromocao.Font.Height := -11;
    pnlItensPromocao.Font.Name := 'Tahoma';
    pnlItensPromocao.Font.Style := [fsBold];
    pnlItensPromocao.ParentFont := False;
    pnlItensPromocao.TabOrder := 33;
    pnlItensPromocao.Visible := False;
    btnItensTab.SetParentComponent(Self);
    btnItensTab.Name := 'btnItensTab';
    btnItensTab.Left := 667;
    btnItensTab.Top := 150;
    btnItensTab.Width := 78;
    btnItensTab.Height := 25;
    btnItensTab.Caption := 'Itens';
    btnItensTab.ChildOrder := 34;
    btnItensTab.HeightPercent := 100.000000000000000000;
    btnItensTab.TabOrder := 1;
    btnItensTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnItensTab, Self, 'OnClick', 'btnItensTabClick');
    lcPaginatorItens.SetParentComponent(Self);
    lcPaginatorItens.Name := 'lcPaginatorItens';
    lcPaginatorItens.Left := 624;
    lcPaginatorItens.Top := 281;
    lcPaginatorItens.Width := 121;
    lcPaginatorItens.Height := 13;
    lcPaginatorItens.HeightPercent := 100.000000000000000000;
    lcPaginatorItens.WidthPercent := 100.000000000000000000;
    lcPaginatorItens.ChildOrder := 132;
    lcPaginatorItens.DefaultItemClassName := 'page-item';
    lcPaginatorItens.DefaultItemLinkClassName := 'page-link';
    lcPaginatorItens.ElementListClassName := 'pagination';
    lcPaginatorItens.Items.Clear;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorItens.Style := lsPagination;
    pnlTabelaAReceber.SetParentComponent(Self);
    pnlTabelaAReceber.Name := 'pnlTabelaAReceber';
    pnlTabelaAReceber.Left := 262;
    pnlTabelaAReceber.Top := 327;
    pnlTabelaAReceber.Width := 225;
    pnlTabelaAReceber.Height := 17;
    pnlTabelaAReceber.Caption := 'Espa'#231'o AReceber';
    pnlTabelaAReceber.ChildOrder := 23;
    pnlTabelaAReceber.Color := clInfoText;
    pnlTabelaAReceber.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaAReceber.Font.Color := clWhite;
    pnlTabelaAReceber.Font.Height := -11;
    pnlTabelaAReceber.Font.Name := 'Tahoma';
    pnlTabelaAReceber.Font.Style := [fsBold];
    pnlTabelaAReceber.ParentFont := False;
    pnlTabelaAReceber.TabOrder := 36;
    pnlTabelaAReceber.Visible := False;
    tblAReceber.SetParentComponent(Self);
    tblAReceber.Name := 'tblAReceber';
    tblAReceber.Left := 266;
    tblAReceber.Top := 371;
    tblAReceber.Width := 225;
    tblAReceber.Height := 102;
    tblAReceber.ElementClassName := 'table-responsive';
    tblAReceber.BorderColor := clSilver;
    tblAReceber.ChildOrder := 82;
    tblAReceber.ColHeader := False;
    tblAReceber.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAReceber, Self, 'OnGetCellData', 'tblAReceberGetCellData');
    SetEvent(tblAReceber, Self, 'OnGetCellClass', 'tblAReceberGetCellClass');
    tblAReceber.Columns.Clear;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'Doc./Parcela';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'Emiss'#227'o';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'Vencimento';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_saldo_pendente';
      Title := 'Saldo Pendente';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_pago';
      Title := 'Valor Pago';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor Total';
    end;
    tblAReceber.DataSource := dtsAReceber;
    lcPaginatorAReceber.SetParentComponent(Self);
    lcPaginatorAReceber.Name := 'lcPaginatorAReceber';
    lcPaginatorAReceber.Left := 385;
    lcPaginatorAReceber.Top := 479;
    lcPaginatorAReceber.Width := 102;
    lcPaginatorAReceber.Height := 15;
    lcPaginatorAReceber.HeightPercent := 100.000000000000000000;
    lcPaginatorAReceber.WidthPercent := 100.000000000000000000;
    lcPaginatorAReceber.ChildOrder := 81;
    lcPaginatorAReceber.DefaultItemClassName := 'page-item';
    lcPaginatorAReceber.DefaultItemLinkClassName := 'page-link';
    lcPaginatorAReceber.ElementListClassName := 'pagination';
    lcPaginatorAReceber.Items.Clear;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorAReceber.Style := lsPagination;
    tblRecebimentos.SetParentComponent(Self);
    tblRecebimentos.Name := 'tblRecebimentos';
    tblRecebimentos.Left := 521;
    tblRecebimentos.Top := 371;
    tblRecebimentos.Width := 225;
    tblRecebimentos.Height := 97;
    tblRecebimentos.ElementClassName := 'table-responsive';
    tblRecebimentos.BorderColor := clSilver;
    tblRecebimentos.ChildOrder := 82;
    tblRecebimentos.ColHeader := False;
    tblRecebimentos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblRecebimentos, Self, 'OnGetCellClass', 'tblRecebimentosGetCellClass');
    tblRecebimentos.Columns.Clear;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'areceber.documento';
      Title := 'Doc./Parcela';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'modalidade.nome';
      Title := 'Modalidade';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'data_recebimento';
      Title := 'Data Recebimento';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'valor_bruto_recebido';
      Title := 'Valor';
    end;
    tblRecebimentos.DataSource := dtsRecebimentos;
    pnlTabelaPagamentos.SetParentComponent(Self);
    pnlTabelaPagamentos.Name := 'pnlTabelaPagamentos';
    pnlTabelaPagamentos.Left := 519;
    pnlTabelaPagamentos.Top := 326;
    pnlTabelaPagamentos.Width := 227;
    pnlTabelaPagamentos.Height := 17;
    pnlTabelaPagamentos.Caption := 'Espa'#231'o Pagamentos';
    pnlTabelaPagamentos.ChildOrder := 23;
    pnlTabelaPagamentos.Color := clInfoText;
    pnlTabelaPagamentos.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaPagamentos.Font.Color := clWhite;
    pnlTabelaPagamentos.Font.Height := -11;
    pnlTabelaPagamentos.Font.Name := 'Tahoma';
    pnlTabelaPagamentos.Font.Style := [fsBold];
    pnlTabelaPagamentos.ParentFont := False;
    pnlTabelaPagamentos.TabOrder := 40;
    pnlTabelaPagamentos.Visible := False;
    btnFinanceiroTab.SetParentComponent(Self);
    btnFinanceiroTab.Name := 'btnFinanceiroTab';
    btnFinanceiroTab.Left := 266;
    btnFinanceiroTab.Top := 345;
    btnFinanceiroTab.Width := 78;
    btnFinanceiroTab.Height := 25;
    btnFinanceiroTab.Caption := 'Financeiro';
    btnFinanceiroTab.ChildOrder := 34;
    btnFinanceiroTab.HeightPercent := 100.000000000000000000;
    btnFinanceiroTab.TabOrder := 1;
    btnFinanceiroTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFinanceiroTab, Self, 'OnClick', 'btnFinanceiroTabClick');
    btnRecebimentosTab.SetParentComponent(Self);
    btnRecebimentosTab.Name := 'btnRecebimentosTab';
    btnRecebimentosTab.Left := 521;
    btnRecebimentosTab.Top := 345;
    btnRecebimentosTab.Width := 78;
    btnRecebimentosTab.Height := 25;
    btnRecebimentosTab.Caption := 'Recebimentos';
    btnRecebimentosTab.ChildOrder := 34;
    btnRecebimentosTab.HeightPercent := 100.000000000000000000;
    btnRecebimentosTab.TabOrder := 1;
    btnRecebimentosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnRecebimentosTab, Self, 'OnClick', 'btnRecebimentosTabClick');
    lcPaginatorRecebimentos.SetParentComponent(Self);
    lcPaginatorRecebimentos.Name := 'lcPaginatorRecebimentos';
    lcPaginatorRecebimentos.Left := 644;
    lcPaginatorRecebimentos.Top := 474;
    lcPaginatorRecebimentos.Width := 102;
    lcPaginatorRecebimentos.Height := 15;
    lcPaginatorRecebimentos.HeightPercent := 100.000000000000000000;
    lcPaginatorRecebimentos.WidthPercent := 100.000000000000000000;
    lcPaginatorRecebimentos.ChildOrder := 81;
    lcPaginatorRecebimentos.DefaultItemClassName := 'page-item';
    lcPaginatorRecebimentos.DefaultItemLinkClassName := 'page-link';
    lcPaginatorRecebimentos.ElementListClassName := 'pagination';
    lcPaginatorRecebimentos.Items.Clear;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorRecebimentos.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Vendas_ServicosDataset;
    DataSource.Left := 144;
    DataSource.Top := 392;
    Vendas_ServicosDataset.SetParentComponent(Self);
    Vendas_ServicosDataset.Name := 'Vendas_ServicosDataset';
    Vendas_ServicosDataset.AfterApplyUpdates := Vendas_ServicosDatasetAfterApplyUpdates;
    Vendas_ServicosDataset.EntitySetName := 'Vendas_Servicos';
    Vendas_ServicosDataset.Connection := DMConnection.ApiConnection;
    Vendas_ServicosDataset.Left := 16;
    Vendas_ServicosDataset.Top := 400;
    Vendas_ServicosDatasetid.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetid.Name := 'Vendas_ServicosDatasetid';
    Vendas_ServicosDatasetid.FieldName := 'id';
    Vendas_ServicosDatasetid.Required := True;
    Vendas_ServicosDatasetaliado_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetaliado_id.Name := 'Vendas_ServicosDatasetaliado_id';
    Vendas_ServicosDatasetaliado_id.FieldName := 'aliado_id';
    Vendas_ServicosDatasetaliado_id.Required := True;
    Vendas_ServicosDatasetdata_base_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetdata_base_id.Name := 'Vendas_ServicosDatasetdata_base_id';
    Vendas_ServicosDatasetdata_base_id.FieldName := 'data_base_id';
    Vendas_ServicosDatasetdata_base_id.Required := True;
    Vendas_ServicosDatasetcliente_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetcliente_id.Name := 'Vendas_ServicosDatasetcliente_id';
    Vendas_ServicosDatasetcliente_id.FieldName := 'cliente_id';
    Vendas_ServicosDatasetcliente_id.Required := True;
    Vendas_ServicosDatasetfuncionario_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetfuncionario_id.Name := 'Vendas_ServicosDatasetfuncionario_id';
    Vendas_ServicosDatasetfuncionario_id.FieldName := 'funcionario_id';
    Vendas_ServicosDatasetnota_numero.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_numero.Name := 'Vendas_ServicosDatasetnota_numero';
    Vendas_ServicosDatasetnota_numero.FieldName := 'nota_numero';
    Vendas_ServicosDatasetnota_numero.Size := 255;
    Vendas_ServicosDatasetnota_emissao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_emissao.Name := 'Vendas_ServicosDatasetnota_emissao';
    Vendas_ServicosDatasetnota_emissao.FieldName := 'nota_emissao';
    Vendas_ServicosDatasetnota_emissao.DisplayFormat := 'dd/mm/yy';
    Vendas_ServicosDatasetnota_entrada_saida.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_entrada_saida.Name := 'Vendas_ServicosDatasetnota_entrada_saida';
    Vendas_ServicosDatasetnota_entrada_saida.FieldName := 'nota_entrada_saida';
    Vendas_ServicosDatasetnota_entrada_saida.DisplayFormat := 'dd/mm/yy';
    Vendas_ServicosDatasetdata_movimento.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetdata_movimento.Name := 'Vendas_ServicosDatasetdata_movimento';
    Vendas_ServicosDatasetdata_movimento.FieldName := 'data_movimento';
    Vendas_ServicosDatasetdata_movimento.DisplayFormat := 'dd/mm/yy';
    Vendas_ServicosDatasetnota_valor_acrescimos.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_valor_acrescimos.Name := 'Vendas_ServicosDatasetnota_valor_acrescimos';
    Vendas_ServicosDatasetnota_valor_acrescimos.FieldName := 'nota_valor_acrescimos';
    Vendas_ServicosDatasetnota_valor_acrescimos.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetnota_valor_desconto.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_valor_desconto.Name := 'Vendas_ServicosDatasetnota_valor_desconto';
    Vendas_ServicosDatasetnota_valor_desconto.FieldName := 'nota_valor_desconto';
    Vendas_ServicosDatasetnota_valor_desconto.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetnota_valor_total.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_valor_total.Name := 'Vendas_ServicosDatasetnota_valor_total';
    Vendas_ServicosDatasetnota_valor_total.FieldName := 'nota_valor_total';
    Vendas_ServicosDatasetnota_valor_total.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetnota_origem.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_origem.Name := 'Vendas_ServicosDatasetnota_origem';
    Vendas_ServicosDatasetnota_origem.FieldName := 'nota_origem';
    Vendas_ServicosDatasetnota_base_issqn.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_base_issqn.Name := 'Vendas_ServicosDatasetnota_base_issqn';
    Vendas_ServicosDatasetnota_base_issqn.FieldName := 'nota_base_issqn';
    Vendas_ServicosDatasetnota_base_issqn.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetnota_valor_issqn.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_valor_issqn.Name := 'Vendas_ServicosDatasetnota_valor_issqn';
    Vendas_ServicosDatasetnota_valor_issqn.FieldName := 'nota_valor_issqn';
    Vendas_ServicosDatasetnota_valor_issqn.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetnota_valor_issqn_retido.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_valor_issqn_retido.Name := 'Vendas_ServicosDatasetnota_valor_issqn_retido';
    Vendas_ServicosDatasetnota_valor_issqn_retido.FieldName := 'nota_valor_issqn_retido';
    Vendas_ServicosDatasetnota_valor_issqn_retido.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetnfse_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnfse_id.Name := 'Vendas_ServicosDatasetnfse_id';
    Vendas_ServicosDatasetnfse_id.FieldName := 'nfse_id';
    Vendas_ServicosDatasetnfse_id.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetosv_oss_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetosv_oss_id.Name := 'Vendas_ServicosDatasetosv_oss_id';
    Vendas_ServicosDatasetosv_oss_id.FieldName := 'osv_oss_id';
    Vendas_ServicosDatasetose_oss_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetose_oss_id.Name := 'Vendas_ServicosDatasetose_oss_id';
    Vendas_ServicosDatasetose_oss_id.FieldName := 'ose_oss_id';
    Vendas_ServicosDatasetpet_prontuarios_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetpet_prontuarios_id.Name := 'Vendas_ServicosDatasetpet_prontuarios_id';
    Vendas_ServicosDatasetpet_prontuarios_id.FieldName := 'pet_prontuarios_id';
    Vendas_ServicosDatasetpet_vendas_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetpet_vendas_id.Name := 'Vendas_ServicosDatasetpet_vendas_id';
    Vendas_ServicosDatasetpet_vendas_id.FieldName := 'pet_vendas_id';
    Vendas_ServicosDatasetmensalidade_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetmensalidade_id.Name := 'Vendas_ServicosDatasetmensalidade_id';
    Vendas_ServicosDatasetmensalidade_id.FieldName := 'mensalidade_id';
    Vendas_ServicosDatasetformas_pagamentos_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetformas_pagamentos_id.Name := 'Vendas_ServicosDatasetformas_pagamentos_id';
    Vendas_ServicosDatasetformas_pagamentos_id.FieldName := 'formas_pagamentos_id';
    SetEvent(Vendas_ServicosDatasetformas_pagamentos_id, Self, 'OnGetText', 'Vendas_ServicosDatasetformas_pagamentos_idGetText');
    Vendas_ServicosDatasetcliente_fidelidade_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetcliente_fidelidade_id.Name := 'Vendas_ServicosDatasetcliente_fidelidade_id';
    Vendas_ServicosDatasetcliente_fidelidade_id.FieldName := 'cliente_fidelidade_id';
    Vendas_ServicosDatasetconvenios_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetconvenios_id.Name := 'Vendas_ServicosDatasetconvenios_id';
    Vendas_ServicosDatasetconvenios_id.FieldName := 'convenios_id';
    Vendas_ServicosDatasetdependentes_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetdependentes_id.Name := 'Vendas_ServicosDatasetdependentes_id';
    Vendas_ServicosDatasetdependentes_id.FieldName := 'dependentes_id';
    Vendas_ServicosDatasetobservacoes.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetobservacoes.Name := 'Vendas_ServicosDatasetobservacoes';
    Vendas_ServicosDatasetobservacoes.FieldName := 'observacoes';
    Vendas_ServicosDatasetobservacoes.Size := 255;
    Vendas_ServicosDatasetnome_consumidor_final.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnome_consumidor_final.Name := 'Vendas_ServicosDatasetnome_consumidor_final';
    Vendas_ServicosDatasetnome_consumidor_final.FieldName := 'nome_consumidor_final';
    Vendas_ServicosDatasetnome_consumidor_final.Size := 255;
    Vendas_ServicosDatasetcodigo_interno.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetcodigo_interno.Name := 'Vendas_ServicosDatasetcodigo_interno';
    Vendas_ServicosDatasetcodigo_interno.FieldName := 'codigo_interno';
    Vendas_ServicosDatasetcodigo_interno.Required := True;
    Vendas_ServicosDatasetexcluido.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetexcluido.Name := 'Vendas_ServicosDatasetexcluido';
    Vendas_ServicosDatasetexcluido.FieldName := 'excluido';
    Vendas_ServicosDatasetinclusao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetinclusao.Name := 'Vendas_ServicosDatasetinclusao';
    Vendas_ServicosDatasetinclusao.FieldName := 'inclusao';
    Vendas_ServicosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Vendas_ServicosDatasetalteracao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetalteracao.Name := 'Vendas_ServicosDatasetalteracao';
    Vendas_ServicosDatasetalteracao.FieldName := 'alteracao';
    Vendas_ServicosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Vendas_ServicosDatasetexclusao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetexclusao.Name := 'Vendas_ServicosDatasetexclusao';
    Vendas_ServicosDatasetexclusao.FieldName := 'exclusao';
    Vendas_ServicosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Vendas_ServicosDatasetclienterazao_social_nome.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetclienterazao_social_nome.Name := 'Vendas_ServicosDatasetclienterazao_social_nome';
    Vendas_ServicosDatasetclienterazao_social_nome.FieldName := 'cliente.razao_social_nome';
    Vendas_ServicosDatasetfuncionarionome.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetfuncionarionome.Name := 'Vendas_ServicosDatasetfuncionarionome';
    Vendas_ServicosDatasetfuncionarionome.FieldName := 'funcionario.nome';
    Vendas_ServicosDatasetnfsedata_emissao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnfsedata_emissao.Name := 'Vendas_ServicosDatasetnfsedata_emissao';
    Vendas_ServicosDatasetnfsedata_emissao.FieldName := 'nfse.data_emissao';
    Vendas_ServicosDatasetnfsechave_acesso.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnfsechave_acesso.Name := 'Vendas_ServicosDatasetnfsechave_acesso';
    Vendas_ServicosDatasetnfsechave_acesso.FieldName := 'nfse.chave_acesso';
    Vendas_ServicosDatasetcliente_fidrazao_social_nome.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetcliente_fidrazao_social_nome.Name := 'Vendas_ServicosDatasetcliente_fidrazao_social_nome';
    Vendas_ServicosDatasetcliente_fidrazao_social_nome.FieldName := 'cliente_fid.razao_social_nome';
    XDataClientVendas_ServicosGet.SetParentComponent(Self);
    XDataClientVendas_ServicosGet.Name := 'XDataClientVendas_ServicosGet';
    XDataClientVendas_ServicosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientVendas_ServicosGet, Self, 'OnLoad', 'XDataClientVendas_ServicosGetLoad');
    XDataClientVendas_ServicosGet.Left := 88;
    XDataClientVendas_ServicosGet.Top := 440;
    cdsItens.SetParentComponent(Self);
    cdsItens.Name := 'cdsItens';
    cdsItens.EntitySetName := 'Itens_Servicos';
    cdsItens.Connection := DMConnection.ApiConnection;
    cdsItens.Left := 600;
    cdsItens.Top := 188;
    cdsItensservico_id.SetParentComponent(cdsItens);
    cdsItensservico_id.Name := 'cdsItensservico_id';
    cdsItensservico_id.FieldName := 'servico_id';
    cdsItensservico_id.Required := True;
    cdsItensquantidade.SetParentComponent(cdsItens);
    cdsItensquantidade.Name := 'cdsItensquantidade';
    cdsItensquantidade.FieldName := 'quantidade';
    cdsItensquantidade.DisplayFormat := '#,##0.000';
    cdsItensservico_preco.SetParentComponent(cdsItens);
    cdsItensservico_preco.Name := 'cdsItensservico_preco';
    cdsItensservico_preco.FieldName := 'servico_preco';
    cdsItensservico_preco.DisplayFormat := '#,##0.00';
    cdsItensserviconome.SetParentComponent(cdsItens);
    cdsItensserviconome.Name := 'cdsItensserviconome';
    cdsItensserviconome.FieldName := 'servico.nome';
    cdsItensservicocodigo_interno.SetParentComponent(cdsItens);
    cdsItensservicocodigo_interno.Name := 'cdsItensservicocodigo_interno';
    cdsItensservicocodigo_interno.FieldName := 'servico.codigo_interno';
    cdsItensservicounidadesigla.SetParentComponent(cdsItens);
    cdsItensservicounidadesigla.Name := 'cdsItensservicounidadesigla';
    cdsItensservicounidadesigla.FieldName := 'servico.unidade.sigla';
    cdsItensvalor_desconto.SetParentComponent(cdsItens);
    cdsItensvalor_desconto.Name := 'cdsItensvalor_desconto';
    cdsItensvalor_desconto.FieldName := 'valor_desconto';
    cdsItensvalor_desconto.DisplayFormat := '#,##0.00';
    cdsItensvalor_acrescimo.SetParentComponent(cdsItens);
    cdsItensvalor_acrescimo.Name := 'cdsItensvalor_acrescimo';
    cdsItensvalor_acrescimo.FieldName := 'valor_acrescimo';
    cdsItensvalor_acrescimo.DisplayFormat := '#,##0.00';
    cdsItenstotal_liquido.SetParentComponent(cdsItens);
    cdsItenstotal_liquido.Name := 'cdsItenstotal_liquido';
    cdsItenstotal_liquido.Tag := 1;
    cdsItenstotal_liquido.FieldKind := fkCalculated;
    cdsItenstotal_liquido.FieldName := 'total_liquido';
    SetEvent(cdsItenstotal_liquido, Self, 'OnGetText', 'cdsItenstotal_liquidoGetText');
    cdsItenstotal_liquido.Calculated := True;
    cdsItensvalor_total.SetParentComponent(cdsItens);
    cdsItensvalor_total.Name := 'cdsItensvalor_total';
    cdsItensvalor_total.Tag := 1;
    cdsItensvalor_total.FieldName := 'valor_total';
    cdsItensvalor_issqn_retido.SetParentComponent(cdsItens);
    cdsItensvalor_issqn_retido.Name := 'cdsItensvalor_issqn_retido';
    cdsItensvalor_issqn_retido.Tag := 1;
    cdsItensvalor_issqn_retido.FieldName := 'valor_issqn_retido';
    dtsItens.SetParentComponent(Self);
    dtsItens.Name := 'dtsItens';
    dtsItens.DataSet := cdsItens;
    dtsItens.Left := 544;
    dtsItens.Top := 188;
    tmrConsultaItens.SetParentComponent(Self);
    tmrConsultaItens.Name := 'tmrConsultaItens';
    tmrConsultaItens.Enabled := False;
    SetEvent(tmrConsultaItens, Self, 'OnTimer', 'tmrConsultaItensTimer');
    tmrConsultaItens.Left := 672;
    tmrConsultaItens.Top := 207;
    cdsRecebimentos.SetParentComponent(Self);
    cdsRecebimentos.Name := 'cdsRecebimentos';
    cdsRecebimentos.EntitySetName := 'Recebimentos';
    cdsRecebimentos.Connection := DMConnection.ApiConnection;
    cdsRecebimentos.QueryTop := 10;
    cdsRecebimentos.Left := 546;
    cdsRecebimentos.Top := 395;
    cdsRecebimentosvalor_bruto_recebido.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosvalor_bruto_recebido.Name := 'cdsRecebimentosvalor_bruto_recebido';
    cdsRecebimentosvalor_bruto_recebido.FieldName := 'valor_bruto_recebido';
    cdsRecebimentosvalor_bruto_recebido.DisplayFormat := '#,##0.00';
    cdsRecebimentosdata_recebimento.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosdata_recebimento.Name := 'cdsRecebimentosdata_recebimento';
    cdsRecebimentosdata_recebimento.FieldName := 'data_recebimento';
    cdsRecebimentosdata_recebimento.DisplayFormat := 'dd/mm/yy';
    cdsRecebimentosmodalidadenome.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosmodalidadenome.Name := 'cdsRecebimentosmodalidadenome';
    cdsRecebimentosmodalidadenome.FieldName := 'modalidade.nome';
    cdsRecebimentosareceberdocumento.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosareceberdocumento.Name := 'cdsRecebimentosareceberdocumento';
    cdsRecebimentosareceberdocumento.FieldName := 'areceber.documento';
    cdsRecebimentosareceberparcela.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosareceberparcela.Name := 'cdsRecebimentosareceberparcela';
    cdsRecebimentosareceberparcela.FieldName := 'areceber.parcela';
    dtsRecebimentos.SetParentComponent(Self);
    dtsRecebimentos.Name := 'dtsRecebimentos';
    dtsRecebimentos.DataSet := cdsRecebimentos;
    dtsRecebimentos.Left := 666;
    dtsRecebimentos.Top := 395;
    dtsAReceber.SetParentComponent(Self);
    dtsAReceber.Name := 'dtsAReceber';
    dtsAReceber.DataSet := cdsAReceber;
    dtsAReceber.Left := 416;
    dtsAReceber.Top := 392;
    cdsAReceber.SetParentComponent(Self);
    cdsAReceber.Name := 'cdsAReceber';
    cdsAReceber.EntitySetName := 'Areceber';
    cdsAReceber.Connection := DMConnection.ApiConnection;
    cdsAReceber.Left := 360;
    cdsAReceber.Top := 400;
    cdsAReceberdocumento.SetParentComponent(cdsAReceber);
    cdsAReceberdocumento.Name := 'cdsAReceberdocumento';
    cdsAReceberdocumento.FieldName := 'documento';
    cdsAReceberdocumento.Size := 255;
    cdsAReceberparcela.SetParentComponent(cdsAReceber);
    cdsAReceberparcela.Name := 'cdsAReceberparcela';
    cdsAReceberparcela.FieldName := 'parcela';
    cdsAReceberparcela.Size := 255;
    cdsAReceberemissao.SetParentComponent(cdsAReceber);
    cdsAReceberemissao.Name := 'cdsAReceberemissao';
    cdsAReceberemissao.FieldName := 'emissao';
    cdsAReceberemissao.DisplayFormat := 'dd/mm/yy';
    cdsARecebervencimento.SetParentComponent(cdsAReceber);
    cdsARecebervencimento.Name := 'cdsARecebervencimento';
    cdsARecebervencimento.FieldName := 'vencimento';
    cdsARecebervencimento.Required := True;
    cdsARecebervencimento.DisplayFormat := 'dd/mm/yy';
    cdsARecebervalor_total.SetParentComponent(cdsAReceber);
    cdsARecebervalor_total.Name := 'cdsARecebervalor_total';
    cdsARecebervalor_total.FieldName := 'valor_total';
    cdsARecebervalor_total.Required := True;
    cdsARecebervalor_total.DisplayFormat := '#,##0.00';
    cdsARecebervalor_saldo_pendente.SetParentComponent(cdsAReceber);
    cdsARecebervalor_saldo_pendente.Name := 'cdsARecebervalor_saldo_pendente';
    cdsARecebervalor_saldo_pendente.FieldName := 'valor_saldo_pendente';
    cdsARecebervalor_saldo_pendente.DisplayFormat := '#,##0.00';
    cdsARecebervalor_pago.SetParentComponent(cdsAReceber);
    cdsARecebervalor_pago.Name := 'cdsARecebervalor_pago';
    cdsARecebervalor_pago.FieldName := 'valor_pago';
    cdsARecebervalor_pago.DisplayFormat := '#,##0.00';
  finally
    lbid.AfterLoadDFMValues;
    lbcliente_id.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    lbnota_numero.AfterLoadDFMValues;
    lbnota_emissao.AfterLoadDFMValues;
    lbnota_entrada_saida.AfterLoadDFMValues;
    lbdata_movimento.AfterLoadDFMValues;
    lbnota_valor_acrescimos.AfterLoadDFMValues;
    lbnota_valor_desconto.AfterLoadDFMValues;
    lbnota_valor_total.AfterLoadDFMValues;
    lbnota_origem.AfterLoadDFMValues;
    lbnota_base_issqn.AfterLoadDFMValues;
    lbnota_valor_issqn.AfterLoadDFMValues;
    lbnota_valor_issqn_retido.AfterLoadDFMValues;
    lbformas_pagamentos_id.AfterLoadDFMValues;
    lbcliente_fidelidade_id.AfterLoadDFMValues;
    lbobservacoes.AfterLoadDFMValues;
    lbnome_consumidor_final.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbchave_acesso.AfterLoadDFMValues;
    lbnfse_emissao.AfterLoadDFMValues;
    lbPaginationInfoItens.AfterLoadDFMValues;
    lbPaginationInfoAReceber.AfterLoadDFMValues;
    lbPaginationInfoRecebimentos.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edcliente_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    ednota_numero.AfterLoadDFMValues;
    ednota_emissao.AfterLoadDFMValues;
    ednota_entrada_saida.AfterLoadDFMValues;
    eddata_movimento.AfterLoadDFMValues;
    ednota_valor_acrescimos.AfterLoadDFMValues;
    ednota_valor_desconto.AfterLoadDFMValues;
    ednota_valor_total.AfterLoadDFMValues;
    ednota_origem.AfterLoadDFMValues;
    ednota_base_issqn.AfterLoadDFMValues;
    ednota_valor_issqn.AfterLoadDFMValues;
    ednota_valor_issqn_retido.AfterLoadDFMValues;
    edformas_pagamentos_id.AfterLoadDFMValues;
    edcliente_fidelidade_id.AfterLoadDFMValues;
    edobservacoes.AfterLoadDFMValues;
    ednome_consumidor_final.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    pnlFormDados.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    pnlFormNfe.AfterLoadDFMValues;
    edchave_acesso.AfterLoadDFMValues;
    ednfe_transmissao.AfterLoadDFMValues;
    btnCopiarChaveAcesso.AfterLoadDFMValues;
    btnNfseTab.AfterLoadDFMValues;
    tblItens.AfterLoadDFMValues;
    cbPageSizeItens.AfterLoadDFMValues;
    edSearchItens.AfterLoadDFMValues;
    pnlItensPromocao.AfterLoadDFMValues;
    btnItensTab.AfterLoadDFMValues;
    lcPaginatorItens.AfterLoadDFMValues;
    pnlTabelaAReceber.AfterLoadDFMValues;
    tblAReceber.AfterLoadDFMValues;
    lcPaginatorAReceber.AfterLoadDFMValues;
    tblRecebimentos.AfterLoadDFMValues;
    pnlTabelaPagamentos.AfterLoadDFMValues;
    btnFinanceiroTab.AfterLoadDFMValues;
    btnRecebimentosTab.AfterLoadDFMValues;
    lcPaginatorRecebimentos.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Vendas_ServicosDataset.AfterLoadDFMValues;
    Vendas_ServicosDatasetid.AfterLoadDFMValues;
    Vendas_ServicosDatasetaliado_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetdata_base_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetcliente_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetfuncionario_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_numero.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_emissao.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_entrada_saida.AfterLoadDFMValues;
    Vendas_ServicosDatasetdata_movimento.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_valor_acrescimos.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_valor_desconto.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_valor_total.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_origem.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_base_issqn.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_valor_issqn.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_valor_issqn_retido.AfterLoadDFMValues;
    Vendas_ServicosDatasetnfse_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetosv_oss_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetose_oss_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetpet_prontuarios_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetpet_vendas_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetmensalidade_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetformas_pagamentos_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetcliente_fidelidade_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetconvenios_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetdependentes_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetobservacoes.AfterLoadDFMValues;
    Vendas_ServicosDatasetnome_consumidor_final.AfterLoadDFMValues;
    Vendas_ServicosDatasetcodigo_interno.AfterLoadDFMValues;
    Vendas_ServicosDatasetexcluido.AfterLoadDFMValues;
    Vendas_ServicosDatasetinclusao.AfterLoadDFMValues;
    Vendas_ServicosDatasetalteracao.AfterLoadDFMValues;
    Vendas_ServicosDatasetexclusao.AfterLoadDFMValues;
    Vendas_ServicosDatasetclienterazao_social_nome.AfterLoadDFMValues;
    Vendas_ServicosDatasetfuncionarionome.AfterLoadDFMValues;
    Vendas_ServicosDatasetnfsedata_emissao.AfterLoadDFMValues;
    Vendas_ServicosDatasetnfsechave_acesso.AfterLoadDFMValues;
    Vendas_ServicosDatasetcliente_fidrazao_social_nome.AfterLoadDFMValues;
    XDataClientVendas_ServicosGet.AfterLoadDFMValues;
    cdsItens.AfterLoadDFMValues;
    cdsItensservico_id.AfterLoadDFMValues;
    cdsItensquantidade.AfterLoadDFMValues;
    cdsItensservico_preco.AfterLoadDFMValues;
    cdsItensserviconome.AfterLoadDFMValues;
    cdsItensservicocodigo_interno.AfterLoadDFMValues;
    cdsItensservicounidadesigla.AfterLoadDFMValues;
    cdsItensvalor_desconto.AfterLoadDFMValues;
    cdsItensvalor_acrescimo.AfterLoadDFMValues;
    cdsItenstotal_liquido.AfterLoadDFMValues;
    cdsItensvalor_total.AfterLoadDFMValues;
    cdsItensvalor_issqn_retido.AfterLoadDFMValues;
    dtsItens.AfterLoadDFMValues;
    tmrConsultaItens.AfterLoadDFMValues;
    cdsRecebimentos.AfterLoadDFMValues;
    cdsRecebimentosvalor_bruto_recebido.AfterLoadDFMValues;
    cdsRecebimentosdata_recebimento.AfterLoadDFMValues;
    cdsRecebimentosmodalidadenome.AfterLoadDFMValues;
    cdsRecebimentosareceberdocumento.AfterLoadDFMValues;
    cdsRecebimentosareceberparcela.AfterLoadDFMValues;
    dtsRecebimentos.AfterLoadDFMValues;
    dtsAReceber.AfterLoadDFMValues;
    cdsAReceber.AfterLoadDFMValues;
    cdsAReceberdocumento.AfterLoadDFMValues;
    cdsAReceberparcela.AfterLoadDFMValues;
    cdsAReceberemissao.AfterLoadDFMValues;
    cdsARecebervencimento.AfterLoadDFMValues;
    cdsARecebervalor_total.AfterLoadDFMValues;
    cdsARecebervalor_saldo_pendente.AfterLoadDFMValues;
    cdsARecebervalor_pago.AfterLoadDFMValues;
  end;
end;

end.
